import m from 'mithril'
import deepDiff from 'deep-object-diff/dist/detailed'
import accessDialog from './oauth/access-dialog'
import ScopeDetails from './oauth/scope-details'


export default {
  oninit(vnode) {
    var {client, scopeDetails, prevScopeDetails} = vnode.attrs

    var diff = vnode.state.diff = deepDiff(scopeDetails, prevScopeDetails || [])

    vnode.state.isModifying = client.installed_at &&
      (hasKeys(diff.added) || hasKeys(diff.deleted) || hasKeys(diff.updated))
  },
  view(vnode) {
    if ( ! vnode.state.isModifying ) {
      return nonModifyingGrant(vnode)
    }

    console.log("DIFF", vnode.state.diff)
    return m('.access-dialog',
      m('.body-content.padding.mw-med',
        m('h1', "Modify Access"),
        m('h2', "TODO")
      )
    )
  }
}


function nonModifyingGrant (vnode) {
  var {client, transaction_id, scopeDetails} = vnode.attrs
  var state = vnode.state

  return accessDialog({
    title: "Sign In Request",
    client: client,
    transaction_id: transaction_id
  },
    m('.text-large.py-2',
      client.meta.name ? m('b', client.meta.name) : m('b', 'An ', m('i', 'anonymous app'))
    ),

    m('p',
      "...is requesting access to your BYOD Home for another 24 hours ",
      m('u', "with the same permissions as before.")
    ),

    m('.div', {
      class: state.viewScope ? '' : 'text-margin'
    },
      m('a.btn.btn-sm', {
        style: `width: 11rem;`,
        onclick: () => state.viewScope = ! state.viewScope
      },
        state.viewScope ? "Close" : "View these access permissions"
      ),

      state.viewScope && [
        m('br'),
        m('.text-left.mt-1.pb-2.d-inline-flex.flex-col.flex-justify-center',
          scopeDetails.map( details =>
            m(ScopeDetails, {
              client: client,
              details: details,
            })
          )
        ),
      ],
    ),

    m('p', "In other words, you have already installed this app, but its access has expired."),

    m('button[type=submit].btn.btn-success.btn-block.mb-2', "Re-Authorize " + client.host),
  )
}

function hasKeys (obj) { return Object.keys(obj).length > 0 }
